export default {"src":"/customer-services/_next/static/media/online.0ee14de1.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};